import * as Sentry from '@sentry/vue';
import packageJson from '../package.json';
import { useRouter } from '#imports';

export default defineNuxtPlugin((plugin) => {
  const router = useRouter();
  const config = useRuntimeConfig();
  Sentry.init({
    Vue: plugin.vueApp,
    dsn: 'https://d46d4479fae5e368c045d199151e52f5@o4507496780529664.ingest.de.sentry.io/4507496789770320',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],

    environment: config.public.sentryEnv ?? process.env.NUXT_PUBLIC_SENTRY_ENV,
    release: config.public.sentryRelease ?? packageJson.version,
    enabled: !config.public.sentryDisabled,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
});

